import React, {useEffect, useState} from "react";
import './style.scss';

const noAcceptedReadyOrdersContentOptions = [
    {
        text: (
            <div>
                <div>
                    תנוחו לרגע,
                </div>
                <div>
                    אין הזמנות שממתינות לטיפול
                </div>
            </div>
        )
    },
    {
        text: (
            <div>
                <div>
                    תנוחו לרגע,
                </div>
                <div>
                    אין הזמנות שממתינות לטיפול
                </div>
            </div>
        )
    },
    {
        text: (
            <div>
                <div>
                    תנוחו לרגע,
                </div>
                <div>
                    אין הזמנות שממתינות לטיפול
                </div>
            </div>
        )
    }
];

const noOnTheWayOrdersContentOptions = [
    {
        text: <div>אין הזמנות בדרכים</div>
    }
];

const noDeliveredOrdersContentOptions = [
    {
        text: <div>עדיין אף הזמנה לא נמסרה</div>
    }
];

function generateNoOrdersData(type) {
    if (type === "ACCEPTED_READY") {
        return noAcceptedReadyOrdersContentOptions[Math.floor(Math.random() * noAcceptedReadyOrdersContentOptions.length)];
    } else if (type === "ON_THE_WAY") {
        return noOnTheWayOrdersContentOptions[Math.floor(Math.random() * noOnTheWayOrdersContentOptions.length)];
    } else if (type === "DELIVERED") {
        return noDeliveredOrdersContentOptions[Math.floor(Math.random() * noDeliveredOrdersContentOptions.length)];
    }

    return null;
}

export default function NoOrders(props) {
    const [text, setText] = useState();

    useEffect(() => {
        const generatedData = generateNoOrdersData(props.type);

        setText(generatedData.text);

    }, [props.type]);

    return (
        <div className="no-orders-container">
            <div className="no-orders-content">
                <div className="no-orders-text">
                    {text}
                </div>
            </div>
        </div>
    );
}